/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';
import PropTypes from 'prop-types';

const RequestsSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="15"
    fill="none"
    viewBox="0 0 17 15"
  >
    <path
      fill="currentColor"
      d="M0 4.25a2.125 2.125 0 012.125-2.125h12.75A2.125 2.125 0 0117 4.25v8.5a2.125 2.125 0 01-2.125 2.125H2.125A2.125 2.125 0 010 12.75v-8.5zm2.125-1.063A1.062 1.062 0 001.062 4.25v.23L8.5 8.944l7.438-4.462V4.25a1.062 1.062 0 00-1.063-1.063H2.125zM15.938 5.72l-5.003 3.002 5.002 3.078V5.72zm-.037 7.306L9.91 9.337l-1.409.845-1.409-.845L1.1 13.024a1.062 1.062 0 001.026.789h12.75a1.062 1.062 0 001.026-.788zM1.063 11.8l5.002-3.078-5.003-3.002v6.08z"
    ></path>
  </svg>
);

const NewRequestsSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="15"
    fill="none"
    viewBox="0 0 17 15"
  >
    <path
      fill="currentColor"
      d="M2.125 0A2.125 2.125 0 000 2.125v8.51a2.125 2.125 0 002.125 2.115h5.844a.531.531 0 000-1.063H2.125a1.062 1.062 0 01-1.026-.787L7.09 7.212l1.409.845 7.438-4.463v3.312a.531.531 0 001.062 0V2.125A2.125 2.125 0 0014.875 0H2.125zm3.94 6.596L1.062 9.674v-6.08l5.003 3.002zm-5.003-4.24v-.231a1.062 1.062 0 011.063-1.063h12.75a1.063 1.063 0 011.063 1.063v.23L8.5 6.819 1.062 2.356z"
    ></path>
    <path
      fill="#da2f58"
      d="M13.281 14.875a3.719 3.719 0 100-7.438 3.719 3.719 0 000 7.438zm.531-5.313v1.594a.531.531 0 01-1.062 0V9.562a.531.531 0 011.063 0zm0 3.188a.532.532 0 11-1.063 0 .532.532 0 011.063 0z"
    ></path>
  </svg>
);

export const RequestIcon = ({ hasNewRequests = false, ...props }) => <Icon component={hasNewRequests ? NewRequestsSvg : RequestsSvg} {...props} />;

RequestIcon.propTypes = {
  hasNewRequests: PropTypes.bool
};
